import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertPassouFalhouEnumToBoolean, convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta11Model } from './model-consultaSeguimentoPergunta11'

export const convertConsultaSeguimentoPergunta11ToInput = (
  value: ConsultaSeguimentoPergunta11Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_11_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_11_EXEMPLOS?.PASSOU?.SORRI_QUANDO_VOCE_SORRI),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_11_EXEMPLOS?.PASSOU?.SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_11_EXEMPLOS?.PASSOU?.SORRI_QUANDO_VOCE_VOLTA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_11_EXEMPLOS?.FALHOU?.ESTA_SEMPRE_SORRINDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_11_EXEMPLOS?.FALHOU?.SORRI_PARA_BRINQUEDO_OU_ATIVIDADE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_11_EXEMPLOS?.FALHOU?.SORRI_AO_ACASO_OU_SEM_MOTIVO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_11_08,
      stResposta: convertPassouFalhouEnumToBoolean(value.PERGUNTA_11_FREQUENCIA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
